module.exports = __webpack_public_path__ + "img/file-----3260@1x.11a1e85d.png";